import {useContext, useState} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {CustomerReportContext} from '../../context'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerReportsHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const [showChartModal, setShowChartModal] = useState(false)

  const {
    handleCustomerGroupReportDateChange,
    handleCustomerTypeReportDateChange,
    allEntityPerformanceChartData,
    isAllEntityPerformanceChartDataLoading,
    onAllEntityPerformanceChartIdChange,
    onAllEntityPerformanceChartViewChange,
    onAllEntityPerformanceChartDateRangeChange,
    allEntityPerformanceChartFilters,
  } = useContext(CustomerReportContext)

  const handleDateChange = (startDate: any, endDate: any) => {
    handleCustomerGroupReportDateChange(startDate, endDate)
    handleCustomerTypeReportDateChange(startDate, endDate)
  }
  return (
    <div className='d-flex flex-wrap justify-content-between align-items-center mb-10 gap-5'>
      <div className='d-flex justify-content-center align-items-center'>
        <button onClick={() => setShowChartModal(true)} className='btn btn-outline'>
          <i className='fas fa-chart-line text-primary me-2'></i>
          <span className='text-center'>Shipping Chart</span>
        </button>
      </div>
      <PredefinedDateRange
        cb={handleDateChange}
        defaultValue={dateRangeLabel || 'Last 90 Days'}
        includeCurrantDay={true}
        startDate={MIN_DATE_RANGE}
      />
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={' '}
          entityPerformanceChartData={allEntityPerformanceChartData}
          entityName={`Shipping Report - All`}
          onEntityPerformanceChartIdChange={onAllEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onAllEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onAllEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={allEntityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isAllEntityPerformanceChartDataLoading}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </div>
  )
}
export {CustomerReportsHeader}
